// assets
import {
  DashboardOutlined,
  AuditOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  MessageOutlined,
  WarningOutlined
} from '@ant-design/icons';

const icons = {
  DashboardOutlined,
  AuditOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  MessageOutlined,
  WarningOutlined
};

const workspace = {
  id: 'group-operate',
  title: 'Operate',
  type: 'group',
  children: [
    {
      id: 'overview',
      title: 'Overview',
      type: 'item',
      url: '/overview',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'risks',
      title: 'Risks',
      type: 'item',
      url: '/risks',
      icon: icons.WarningOutlined
    },
    {
      id: 'tasks',
      title: 'Tasks',
      type: 'item',
      url: '/tasks',
      icon: icons.CheckSquareOutlined
    },
    {
      id: 'controls',
      title: 'Controls',
      type: 'item',
      url: '/controls',
      icon: icons.AuditOutlined
    },
    {
      id: 'evidence',
      title: 'Evidence',
      type: 'item',
      url: '/evidence',
      icon: icons.FileSearchOutlined
    },
    {
      id: 'responses',
      title: 'Responses',
      type: 'item',
      url: '/responses',
      icon: icons.MessageOutlined
    },
    {
      id: 'activity',
      title: 'Activity',
      type: 'item',
      url: '/activity',
      icon: icons.ClockCircleOutlined
    }
  ]
};

export default workspace;
